<template>
  <div>
    <v-btn
      v-if="data.type === 'message'"
      @click="action(data, 'messageFun')"
      class="btn-send-sms rounded-lg custom-btn d-block"
      v-status="'smsDetaill_show'"
    >
      <v-icon>mdi-email-check</v-icon>
    </v-btn>
    <v-btn
      v-if="data.type === 'pattern'"
      @click="action(data, 'pattern')"
      class="btn-send-sms rounded-lg custom-btn d-block"
    >
      <v-icon>mdi-email-check</v-icon>
    </v-btn>

    <v-btn
      v-if="data.type === 'history'"
      @click="action(data, 'history')"
      class="btn-history rounded-lg mx-0 d-block custom-btn"
      v-status="'adminUsersbtn_history'"
    >
      <span class="flaticon2-writing icon-lg"></span>
      <!-- <v-icon>mdi-pencil-outline</v-icon> -->
      <!--      <v-icon>mdi-history</v-icon>-->
    </v-btn>
    <v-btn
      v-if="data.type === 'voip'"
      @click="action(data, 'voip')"
      class="btn-report rounded-lg custom-btn d-block"
      v-status="'voipHistory_access'"
    >
      <v-icon>mdi-phone</v-icon>
    </v-btn>
    <v-btn
      v-if="data.type === 'notification'"
      @click="action(data, 'notification')"
      class="btn-cancel rounded-lg custom-btn d-block"
      v-status="'notificationHistoryLog_access'"
    >
      <span class="far fa-bell icon-lg"></span>
      <!-- <v-icon>mdi-bell-outline</v-icon> -->
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "HistoryBtn",
  props: {
    data: {},
    action: {
      type: Function,
    },
  },
};
</script>

<style scoped>
.custom-btn {
  margin: 0px !important;
  padding: 0px !important;
}
</style>
